module.exports = __webpack_public_path__ + "img/thumbnail_Fossa_f_normal.dcd1a8e3.png";